/**
 * Membership visit API service — per-traveler itinerary legs under trip memberships.
 */
import { AxiosResponse } from 'axios';
import { BaseApiService } from './baseApi';
import { TRIPS, MEMBERSHIPS, VISITS } from '../../constants';
import { MembershipVisit, MembershipVisitRequest } from '../../types';
import { ServiceResult, ApiResponse } from '../../types/common/api.types';

const membershipVisitsPath = (tripId: string) =>
  `${TRIPS}/${tripId}${MEMBERSHIPS}${VISITS}`;

export class MembershipVisitApiService extends BaseApiService {
  async addMembershipVisit(
    tripId: string,
    body: MembershipVisitRequest
  ): Promise<ServiceResult<MembershipVisit>> {
    return this.withErrorHandling(async () => {
      const response: AxiosResponse<MembershipVisit> = await this.api.post(
        membershipVisitsPath(tripId),
        body
      );
      return response.data;
    });
  }

  async updateMembershipVisit(
    tripId: string,
    visitId: number,
    body: MembershipVisitRequest
  ): Promise<ServiceResult<MembershipVisit>> {
    return this.withErrorHandling(async () => {
      const response: AxiosResponse<MembershipVisit> = await this.api.put(
        `${membershipVisitsPath(tripId)}/${visitId}`,
        body
      );
      return response.data;
    });
  }

  async deleteMembershipVisit(
    tripId: string,
    visitId: number
  ): Promise<ServiceResult<ApiResponse>> {
    return this.withErrorHandling(async () => {
      const response: AxiosResponse<ApiResponse> = await this.api.delete(
        `${membershipVisitsPath(tripId)}/${visitId}`
      );
      return response.data;
    });
  }
}
